export default {
    // 获取统计列表
    operatingStatementMonthsList: "/report/operatingStatementMonths/show",
    // 下载PDF
    operatingStatementMonthsToPdf: "/report/operatingStatementMonths/export/pdf",
    // 下载CSV
    operatingStatementMonthsToCsv: "/report/operatingStatementMonths/export/csv",
    // 获取report list 列表
    operatingStatementMonthsReportDict: "/report/operatingStatementMonths/reportDict",
    // 获取glChartName列表
    operatingStatementMonthsGlChartNameDict: "/report/operatingStatementMonths/glChartNameDict",        
    // 获取report group list 接口
    operatingStatementAnalysisReportList: "/report/operatingStatementMonths/reportList",
    // report group dict 列表
    operatingStatementAnalysisReportGroupList: "/report/operatingStatementMonths/reportNameDict",
    // acct type list
    operatingStatementAnalysisReportAcctTypeList: "/common/glAcct/getFieldMapping",
    // 创建reportList
    operatingStatementAnalysisCreateReportList: "/report/operatingStatementMonths/createReportList",
    // 修改reportList
    operatingStatementAnalysisUpdateReportList: "/report/operatingStatementMonths/updateReportList",
    // 创建group
    operatingStatementAnalysisCreateGroup: "/report/operatingStatementMonths/createGroup",
    // 根据id修改reportGroup
    operatingStatementAnalysisUpdateGroup: "/report/operatingStatementMonths/updateGroup",
    // 根据id删除group
    operatingStatementAnalysisDeleteGroup: "/report/operatingStatementMonths/deleteGroup",
    // 根据id删除reportList
    operatingStatementAnalysisDeleteList: "/report/operatingStatementMonths/deleteList",
};
